import CustomsWarning from './CustomsWarning';

export default CustomsWarning;



// WEBPACK FOOTER //
// ./src/components/CustomsWarning/index.tsx